import { makeStyles, shorthands } from "@fluentui/react-components";

export const useStyle = makeStyles({
	container: {
		...shorthands.overflow("hidden"),
		width: "100%",
		height: "100%",
	},
	image: {
		width: "100%",
		height: "100%",
		objectFit: "contain",
	},
	loadingContainer: {
		height: "250px",
	},
	header: {
		lineBreak: "anywhere",
	},
});
